import { fetchbase } from '../../utils/api.util';
import { createApi } from '@reduxjs/toolkit/query/react';

export type MetaAdsTag = 'MetaAdsAuth' | 'MetaAdsPages' | 'MetaAdsInstagramAccounts' | 'MetaAdsAdAccounts' | 'MetaAdsPixels' | 'MetaAdsSavedPixels' | 'MetaAdsCampaigns' | 'MetaAdsCampaignsFromMeta' | 'MetaAdsCampaignFromMeta' | 'DraftCampaigns';

export const emptySplitApi = createApi({
  baseQuery: fetchbase,
  tagTypes: ['MetaAdsAuth', 'MetaAdsPages', 'MetaAdsInstagramAccounts', 'MetaAdsAdAccounts', 'MetaAdsPixels', 'MetaAdsSavedPixels', 'MetaAdsCampaigns', 'MetaAdsCampaignsFromMeta', 'MetaAdsCampaignFromMeta', 'DraftCampaigns'] as const,
  endpoints: () => ({}),
});
